import { render, staticRenderFns } from "./navDocument3.vue?vue&type=template&id=1051a2f2&scoped=true&"
import script from "./navDocument3.vue?vue&type=script&lang=js&"
export * from "./navDocument3.vue?vue&type=script&lang=js&"
import style0 from "./navDocument3.vue?vue&type=style&index=0&id=1051a2f2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1051a2f2",
  null
  
)

export default component.exports